import type { ModalStyles } from "@repo/ui";

/** Modal card width matches Figma Group 27786: web 400px, mobile 343px. */
export function getAinaIntroSkipModalLayoutStyles(
  isMobile: boolean,
): ModalStyles {
  return {
    modal: {
      backgroundColor: "transparent",
      boxShadow: "none",
      overflow: "visible",
      width: "100%",
      maxWidth: isMobile ? 343 : 400,
      maxHeight: "none",
    },
    body: {
      flex: "0 0 auto",
      overflow: "visible",
      maxHeight: "none",
      minHeight: 0,
      backgroundColor: "transparent",
    },
  };
}
